<template>
	<div class="iCard">
		<search-i-dard-list
			v-on:onSubmit="onSubmit"
			v-on:resetSearch="resetSearch"
			:search="search"
		>
		</search-i-dard-list>
		<add-i-dard
			:iDard="iDard"
			:countrySet="countrySet"
			v-on:cancel="cancel"
			:dialogIDard="dialogIDard"
		>
		</add-i-dard>
		<div class="vue-padding radius">
			<el-table
				v-loading="loading"
				:empty-text="$t('common.noData')"
				:element-loading-text="$t('common.loading')"
				:data="cardList"
				style="width: 100%"
				max-height="638"
				:border="true"
			>
				<el-table-column
					prop="name"
					:label="$t('iDard.name')"
					:align="'center'"
				></el-table-column>
				<el-table-column
					prop="content"
					:label="$t('iDard.IdInfo')"
					:align="'center'"
				></el-table-column>
				<el-table-column
					prop="type"
					:label="$t('iDard.type')"
					width="230"
					:align="'center'"
				></el-table-column>
				<el-table-column
					prop="year"
					:label="$t('iDard.year')"
					width="100"
					:align="'center'"
				></el-table-column>
				<el-table-column
					prop="month"
					:label="$t('iDard.month')"
					width="100"
					:align="'center'"
				></el-table-column>
				<el-table-column
					prop="day"
					:label="$t('iDard.day')"
					width="100"
					:align="'center'"
				></el-table-column>
				<el-table-column
					prop="createTime"
					:label="$t('iDard.luDate')"
					width="160"
					:align="'center'"
				></el-table-column>
				<el-table-column
					fixed="right"
					:label="$t('common.operate')"
					width="160"
					:align="'center'"
				>
					<template slot-scope="scope">
						<el-button
							size="mini"
							type="primary"
							v-hasPerm="['sys:idard']"
							@click="editIDard(scope.row)"
							>{{ $t("addIDard.edit") }}</el-button
						>
						<el-button
							type="danger"
							v-hasPerm="['sys:card:delete']"
							size="mini"
							@click="delIDard(scope.row)"
							>{{ $t("common.delete") }}</el-button
						>
					</template>
				</el-table-column>
			</el-table>
			<el-pagination
				background
				layout="prev, pager, next"
				:current-page="page.pageIndex"
				:total="page.totalSize"
				:page-size="page.pageSize"
				@current-change="currentChange"
			></el-pagination>
		</div>
	</div>
</template>

<script>
import searchIDardList from "_c/system/ic/SearchIDardList";
import addIDard from "_c/system/ic/AddIDard";
export default {
	name: "IDardlist",
	components: {
		searchIDardList,
		addIDard,
	},
	data() {
		return {
			page: {
				pageSize: 10,
				pageIndex: 1,
			},
			search: {
				name: "",
				type: "",
				startTime: "",
				endDate: "",
			},
			loading: false,
			dialogIDard: false,
			iDard: {
				id: "",
				name: "",
				type: "",
				pdfType: "",
				country: "",
				year: "",
				month: "",
				day: "",
				pdfYear: "",
				pdfMonth: "",
				pdfDay: "",
				content: "",
			},
			countrySet: [],
		};
	},
	mounted() {
		this.getCountry();
		this.currentChange();
	},
	methods: {
		getCountry() {
			this.$api.dict("sys_idcard_country").then(res => {
				if (res.code === 0) {
					this.countrySet = res.data;
				}
			});
		},
		currentChange(pageIndex) {
			this.loading = true;
			this.page.pageIndex = pageIndex ? pageIndex : 1;
			let obj = this.$cloud.objMerge(this.search, this.page);
			this.$api
				.request(this.$url.IDard.pageIDard, this.$method.get, obj)
				.then(res => {
					if (res.code === 0) {
						this.cardList = res.data.records;
						this.page.totalSize = parseInt(res.data.total);
					}
					this.loading = false;
				})
				.catch(() => {
					this.loading = false;
				});
		},
		editIDard(row) {
			let _self = this;
			this.dialogIDard = true;
			Object.keys(_self.iDard).forEach(key => {
				this.iDard[key] = row[key];
			});
		},
		cancel(dialog, state) {
			this.dialogIDard = dialog;
			if (state) {
				this.currentChange();
			}
		},
		onSubmit(data) {
			this.search = data;
			this.currentChange();
		},
		resetSearch(data) {
			this.search = data;
			this.currentChange();
		},
		delIDard(row) {
			this.$confirm(this.$t("iCard.delete"), this.$t("common.warning"), {
				confirmButtonText: this.$t("common.definite"),
				cancelButtonText: this.$t("common.cancel"),
				type: "warning",
			}).then(() => {
				this.$api
					.request(this.$url.IDard.deleteIDard, this.$method.post, {
						id: row.id,
					})
					.then(res => {
						if (res.code === 0) {
							this.$notify({
								title: this.$t("common.tip"),
								message: res.msg,
								type: "success",
							});
							this.currentChange();
						}
					});
			});
		},
	},
};
</script>

<style lang="scss"></style>
